const TermPage = () => {
  return (
    <>
      <div style={{ height: "100vh", width: "100vw", background: "#FFFFFF" }}>
        <iframe src="/terms.html" width="100%" height="100%" title="이용약관" />
      </div>
    </>
  );
};

export default TermPage;
